import { Injectable } from '@angular/core';
import { PopoverController } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class PopoverService {
  constructor(private popoverController: PopoverController) {}

  async create(config: any, event?: any) {
    let cssClasses: string[] = [];

    if (config.cssClass) {
      cssClasses = Array.isArray(config.cssClass) ? config.cssClass : [config.cssClass];
    }

    if (event || config.event) {
      const ev = event || config.event;
      const target = ev.target?.closest('button') || ev.target;
      const rect = target?.getBoundingClientRect();

      if (rect) {
        const viewportHeight = window.innerHeight;
        const distanceFromBottom = viewportHeight - rect.bottom;
        const isNearBottom = distanceFromBottom < 200;

        if (isNearBottom) {
          cssClasses.push('popover-constrain-viewport');
        }
      }
    }

    const finalConfig = {
      ...config,
      cssClass: cssClasses.length > 0 ? cssClasses.join(' ') : undefined,
    };

    return this.popoverController.create(finalConfig);
  }
}
